import React from 'react'

import Image from 'next/image'

import { SectionContainer } from 'Components/Blocks'
import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Button, Column, Row, Text } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/MembershipsCorporateHeroSection'
import { StripedCircleSvg } from 'Assets/Svg'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, Overlay, Title } from './styles'

type Props = {
  onAction?: () => void
}

function MembershipsCorporateHeroSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer>
      <Row fullWidth justifyCenter px={LANDING_CONTENT_PX}>
        <Container mt={5} px={[6, 6, 14, 14, 21]} py={[14, 14, 14, 14, 21]}>
          <Image alt="" src={BackgroundImage} />

          <Overlay />

          <Column
            alignCenter={isMobile}
            alignStart={!isMobile}
            gap={6}
            width={[1, 1, 1 / 2]}
          >
            <AppearingWrapper centered={isMobile} kind="expand">
              <Title flexDirection={['column', 'column', 'row']}>
                {StripedCircleSvg()}

                <Text as="h1" bold center={isMobile} inverse screen18>
                  Get a slice of the action
                </Text>
              </Title>
            </AppearingWrapper>

            <Text
              as="h3"
              bold
              center={isMobile}
              inverse
              mb={5}
              mt={3}
              nowrap={!isMobile}
              screen40={isMobile}
              screen52={!isMobile}
            >
              Corporate Memberships
            </Text>

            <Text
              center={isMobile}
              inverse
              mb={7}
              medium
              screen14={isMobile}
              screen20={!isMobile}
            >
              Whether you’re a lifelong golfer or just learning to love the
              sport, joining Emajin Golf’s inclusive community is the best way
              to ‘Get in the Game!’
            </Text>

            <Button large mb={6} onClick={onAction}>
              Enquire Now
            </Button>
          </Column>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default MembershipsCorporateHeroSection
